module.exports = __webpack_public_path__ + "img/button_skip-video-Text.f95c9b76.svg";